import { Trans } from 'react-i18next'

import mummiesPNG from '~/assets/images/history/history-mummies.png'
import mummiesWEBP from '~/assets/images/history/history-mummies.webp'
import {
  ANSWERS,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'Do you know how the Egyptians made mummies?'

const Mummies = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans ns="history" i18nKey="onboarding.historyMummies.title" />
          </S.Question>

          <S.ImageContainer>
            <picture>
              <source srcSet={mummiesWEBP} type="image/webp" />
              <img src={mummiesPNG} alt="Egyptian pyramids" />
            </picture>
          </S.ImageContainer>
        </div>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default Mummies
